import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IAccountInfo, LogoutUseCase } from '@modules/auth';
import { AuthSessionRead } from '@modules/auth';
import { Subscription } from 'rxjs';
import { SidenavService } from 'src/app/services/sidenav.service';

@Component({
  selector: 'app-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  styleUrls: ['./toolbar-user.component.scss'],
  standalone: false,
})
export class ToolbarUserComponent implements OnInit, OnDestroy {
  isOpen: boolean = false;
  account: IAccountInfo | undefined;
  showId = false;
  subs: Subscription = new Subscription();

  constructor(
    private readonly authSessionService: AuthSessionRead,
    private readonly sidenavService: SidenavService,
    private readonly router: Router,
    private readonly logoutUseCase: LogoutUseCase,
  ) {}

  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  ngOnInit() {
    this.subs = this.sidenavService.showID$.subscribe((data: any) => {
      this.showId = data;
    });
    if (!this.account) {
      const currentUser = this.authSessionService.currentUser ?? {};
      this.account = currentUser as IAccountInfo;
    }
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onClickOutside() {
    this.isOpen = false;
  }

  logout() {
    this.logoutUseCase.execute().subscribe();
  }

  routeLinkSend(link: string) {
    this.router.navigate([link]);
  }
}
